<template>
  <div>
    <!--Charts-->
    <div class="row">
      <div class="col-md-10">
        <div class="embed-responsive iframe embed-responsive-4by3">
           <iframe :src=datastudiourl
                    frameborder="0" 
                    style="border:0" allowfullscree
                    ></iframe>
                    1
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
 props: { 
   datastudiourl: String,
 },
}
</script>